module.exports = __webpack_public_path__ + "static/atendimento-9061bd2bbc174d89916381dad8adf971.png";